import React, { useState } from "react";
import useUserAccountSettings from "../hooks/useUserAccountSettings";
import { Button, Form, Spinner } from "react-bootstrap";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import useForm from "../hooks/useForm";
import CloseAccountModal from "./CloseAccountModal";
import useUserAccount from "../hooks/useUserAccount";
import AccountConnectedEmails from "./AccountConnectedEmails";

const messages = defineMessages({
    phoneValidationError: {
        id: "Puhelinnumeron tulee olla kansainvälisessä muodossa. Esim. +358 50 1234567.",
        defaultMessage: "Puhelinnumeron tulee olla kansainvälisessä muodossa. Esim. +358 50 1234567."
    },
    name: {
        id: "Nimi",
        defaultMessage: "Nimi"
    },
    email: {
        id: "Sähköposti",
        defaultMessage: "Sähköposti"
    },
    phone: {
        id: "Puhelinnumero",
        defaultMessage: "Puhelinnumero"
    },
    country: {
        id: "Asuinmaa",
        defaultMessage: "Asuinmaa"
    },
    streetAddress: {
        id: "Katuosoite",
        defaultMessage: "Katuosoite"
    },
    postalCode: {
        id: "Postinumero",
        defaultMessage: "Postinumero"
    },
    city: {
        id: "Toimipaikka",
        defaultMessage: "Toimipaikka"
    },
    accountDetails: {
        id: "Tilin tiedot",
        defaultMessage: "Tilin tiedot"
    },
    updateInfo: {
        id: "Päivitä tiedot",
        defaultMessage: "Päivitä tiedot"
    },
    closeAccount: {
        id: "Sulje tili",
        defaultMessage: "Sulje tili"
    }
});

const SettingsAccountDetails = (props) => {
    const { settings } = useUserAccountSettings();
    const { userIsCompany, userCompanyName } = useUserAccount();
    const { dirty, form, handleChange, validateForm } = useForm(settings);
    const [showCloseAccountModal, setShowCloseAccountModal] = useState(false);

    const lng = props.intl.formatMessage;

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (validateForm(event.target)) {
            props.onSubmit(form);
        }
    }

    const personalFormElement = (
        <>
            <Form.Floating className="mb-2 pb-2">
                <Form.Control
                    name='streetAddress'
                    value={form.streetAddress}
                    onChange={handleChange}
                />
                <Form.Label htmlFor="streetAddress">{lng(messages.streetAddress)}</Form.Label>
            </Form.Floating>
            <div className='row'>
                <Form.Floating className="mb-2 pb-2 col-md-6">
                    <Form.Control
                        name='postalCode'
                        value={form.postalCode}
                        onChange={handleChange}
                    />
                    <Form.Label htmlFor="postalCode">{lng(messages.postalCode)}</Form.Label>
                </Form.Floating>
                <Form.Floating className="mb-2 pb-2 col-md-6">
                    <Form.Control
                        name='city'
                        value={form.city}
                        onChange={handleChange}
                    />
                    <Form.Label htmlFor="city">{lng(messages.city)}</Form.Label>
                </Form.Floating>
            </div>
            <Form.Floating className="mb-2 pb-2">
                <Form.Control
                    name='country'
                    value={form.country}
                    onChange={handleChange}
                />
                <Form.Label htmlFor="country">{lng(messages.country)}</Form.Label>
            </Form.Floating>
            <Form.Floating className="mb-2 pb-2">
                <Form.Control
                    name='phone'
                    type='tel'
                    pattern='(\+|00)[1-9][0-9 \-\(\)\.]{7,32}'
                    value={form.phone}
                    onChange={handleChange}
                />
                <Form.Label htmlFor="phone">{lng(messages.phone)}</Form.Label>
                <Form.Control.Feedback type="invalid">
                    {lng(messages.phoneValidationError)}
                </Form.Control.Feedback>
            </Form.Floating>
            <Button
                form="settings-personal-form"
                variant="primary"
                type="submit"
                disabled={props.loading || !dirty}
            >
                {props.loading && (<Spinner animation="border" size="sm" />)} {lng(messages.updateInfo)}
            </Button>
        </>
    )

    return (
        <div>
            <h2>{lng(messages.accountDetails)}</h2>
            <Form id='settings-personal-form' onSubmit={handleSubmit} noValidate>
                <Form.Floating className="mb-2 pb-2">
                    <Form.Control
                        disabled
                        name='fullName'
                        value={userIsCompany() ? userCompanyName() : form.fullName}
                        onChange={() => {}}
                    />
                    <Form.Label htmlFor="fullName">{lng(messages.name)}</Form.Label>
                </Form.Floating>
                {!userIsCompany() && personalFormElement}
                {!userIsCompany() && <AccountConnectedEmails currentAccountEmail={form.email} />}
                <hr className='mt-4 mb-2' />
                <Button
                    className='btn-danger-link'
                    onClick={() => setShowCloseAccountModal(true)}
                >
                    {lng(messages.closeAccount)}
                </Button>
            </Form>
            <CloseAccountModal
                show={showCloseAccountModal}
                onHide={() => setShowCloseAccountModal(false)}
            />
        </div>
    )
}

SettingsAccountDetails.propTypes = {
    'intl': PropTypes.object.isRequired,
    'loading': PropTypes.bool.isRequired,
    'onSubmit': PropTypes.func.isRequired
};

export default injectIntl(SettingsAccountDetails);
